export default __webpack_public_path__ + "static/media/klaushack1001.ec8929c1.jpg";